import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, LabelList
} from 'recharts';

const renderStartEndLabel = (theme, data) => (props) => {
  const { x, y, index, value } = props;
  if (index === 0 || index === data.length - 1) {
    return (
      <text 
        x={x} 
        y={y - 16} 
        fill={theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)"} 
        textAnchor="middle" 
        fontSize={18} 
        fontWeight="bold"
      >
        {formatter(value)}
      </text>
    );
  }
  return null;
};

const formatter = (tickValue) => {
  if (!tickValue) return tickValue;
  return `${tickValue.toLocaleString()}`;
};

const CustomLineChart = ({ theme, data }) => {
  // Calculate the minimum and maximum values
  const minValue = Math.min(...data.map(d => d.price));
  const maxValue = Math.max(...data.map(d => d.price));
  
  // Calculate 20% below the min value and 20% above the max value
  const buffer = (maxValue - minValue) * 0.2;
  const adjustedMin = Math.floor(minValue - buffer); // Round down
  const adjustedMax = Math.ceil(maxValue + buffer);  // Round up

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data} margin={{ top: 20, right: 0, left: -10, bottom: 50 }}>
        <CartesianGrid stroke="#eee" vertical={false} />
        <XAxis 
          dataKey="year" 
          tick={{ fill: theme === "dark" ? "#f8ffef" : 'rgb(102, 102, 102)',fontWeight: 600, fontSize: 20 }} 
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : '#eee' }} 
          tickLine={false} 
          interval={0} 
          angle={-45} 
          textAnchor="end"
          padding={{ left: 20, right: 20 }}  
          height={50}
        />
        <YAxis 
          tick={{ fill: theme === "dark" ? "#f8ffef" : 'rgb(102, 102, 102)',fontWeight: 600, fontSize: 20, dx: 5 }} 
          axisLine={false}  
          tickLine={false} 
          tickCount={8}
          domain={[adjustedMin, adjustedMax]}
          tickFormatter={formatter}
        />
        <Line 
          type="monotone" 
          dataKey="price" 
          className="line-chart-element"
          strokeWidth={4} 
          dot={false}
          strokeLinecap="butt"  
        >
          {/* <LabelList content={renderStartEndLabel(theme, data)} /> */}
        </Line>
      </LineChart>
    </ResponsiveContainer>
  );
};

export default CustomLineChart;
